import { SxProps, Tab, Tabs, Theme } from "@mui/material";
import React from "react";

export interface TabItem<T = string> {
    value: T;
    label: string | React.ReactNode;
    disabled?: boolean;
}

export interface TabControlProps<T = string> {
    value: T;
    onChange: (event: React.SyntheticEvent, newValue: T) => void;
    tabs: TabItem<T>[];
    tabsSx?: SxProps<Theme>;
}

export const TabControl = <T extends string | number = string>({
    value,
    onChange,
    tabs,
    tabsSx,
}: TabControlProps<T>) => {
    const defaultTabsSx: SxProps<Theme> = {
        backgroundColor: "#212b40",
        padding: "0 30px",
        marginBottom: "15px",
        "& .MuiTab-root": {
            color: "#ffffff",
            textTransform: "none",
            fontSize: "16px",
            fontWeight: 400,
            "&.Mui-selected": {
                background: "#171f30",
                color: "#00cbaf",
                position: "relative",
                transition: "all 0.5s",
            },
        },
        "& .MuiTabs-indicator": {
            backgroundColor: "#00CBAF",
        },
    };

    const tabsStyles: any[] = [defaultTabsSx];
    if (tabsSx) {
        tabsStyles.push(tabsSx);
    }

    return (
        <Tabs
            value={value}
            onChange={onChange}
            sx={tabsStyles as SxProps<Theme>}
            TabIndicatorProps={{
                sx: {
                    top: 0,
                    bottom: "auto",
                    height: "4px",
                },
            }}
        >
            {tabs.map((tab) => (
                <Tab
                    key={String(tab.value)}
                    disableRipple={true}
                    label={tab.label}
                    value={tab.value}
                    disabled={tab.disabled}
                />
            ))}
        </Tabs>
    );
};
